<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Enquiries' | translate }}</ion-title>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="enquiry-container">

    @if (displayDates.length) {
      <div class="day-picker-wrapper">
        <div class="day-picker">
          <div class="wrapper">

            @for (displayDate of displayDates; track displayDate.date) {
              <div class="ion-activatable ripple-parent day" [class.active]="displayDate.isActive" (click)="selectDays(displayDate.date)">
                <ion-ripple-effect></ion-ripple-effect>
                <p>{{ displayDate.date | localeDate:locale:'MMM' }}</p>
                <p>{{ displayDate.date | date: 'dd' }}</p>
              </div>
            }

            @for (additionalMonths of additionalDisplayMonths; track $index) {
              <div class="ion-activatable ripple-parent day" [class.active]="additionalMonths.isActive" (click)="selectMonths($index)">
                <ion-ripple-effect></ion-ripple-effect>
                <p>{{ additionalMonths.monthCount }}</p>
                <p>{{ 'month' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="enquiry-group-wrapper" rotaAnimate [animationShowTransitionMS]="300" [animateToggle]="(userApplicationGroups | async).length">
      @for (userAppGroup of userApplicationGroups | async; track userAppGroup.status) {
        <div class="enquiry-group">
          <span class="status-label">{{ userAppGroup.status }}</span>

          <div class="enquiry-cards">
            @for (userApp of userAppGroup.userApplications; track userApp.id || $index) {
              <div [class]="'ion-activatable ripple-parent enquiry-card ' + getType(userApp.status)" (click)="openChat(userApp)">
                <ion-ripple-effect></ion-ripple-effect>

                <div class="content-container">
                  <div class="icon-wrapper">
                    <ion-icon class="status" [name]="userAppGroup.icon"></ion-icon>
                  </div>

                  <div class="content-wrapper">
                    <div class="header">
                      <h4 class="label">{{ getUserApplicationTitle(userApp.id) }}</h4>

                      <div class="date-wrapper">
                        @if (!isUserApplicationRead(userApp.id)) {
                          <ion-icon class="icon-status new-message" name="mail"></ion-icon>
                        }
                        @if (isUserApplicationRead(userApp.id)) {
                          <ion-icon class="icon-status" name="mail-open-outline"></ion-icon>
                        }
                        <p class="date">{{ userApp.application.createdAt | date: 'dd.MM.yyyy' }}</p>
                      </div>
                    </div>

                    <div class="message-preview">
                      <p class="text" [class.not-read]="!isUserApplicationRead(userApp.id)" [class.two-line]="true" [class.muted]="true">
                        {{ userApp.application.description }}
                      </p>
                    </div>
                  </div>

                  <div class="arrow-wrapper">
                    <ion-icon name="chevron-forward" />
                  </div>
                </div>

              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (showLoadButton) {
      <ion-button class="load-more-button" (click)="loadMoreApplications()">
        <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        {{ 'Show_More' | translate }}
      </ion-button>

      <div class="ion-text-center">
        <ion-button color="light" (click)="loadMoreApplications()">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          {{ 'Show_More' | translate }}
        </ion-button>
      </div>
    }

  </div>
</ion-content>